export default {
    draft: {
        id: 1,
        name: "Draft",
        tag_type: "info",
        class: "status-badge draft fa-sm",
    },
    pending_approval: {
        id: 2,
        name: "Pending",
        tag_type: "warning",
        class: "status-badge pending fa-sm",
    },
    approved: {
        id: 3,
        name: "Submitted",
        tag_type: "success",
        class: "status-badge approved fa-sm",
    },
    declined: {
        id: 4,
        name: "Declined",
        tag_type: "danger",
        class: "status-badge declined fa-sm",
    },
    awaiting_payment: {
        id: 7,
        name: "Awaiting Payment",
        new_name: "Awaiting Payment",
        tag_type: "success",
        class: "status-badge awaiting fa-sm",
    },
    paid: {
        id: 8,
        name: "Paid",
        new_name: "Paid",
        tag_type: "secondary",
        class: "status-badge paid fa-sm",
    },
    deleted: {
        id: 0,
        name: "Deleted",
        new_name: "Deleted",
        tag_type: "danger",
        class: "status-badge draft fa-sm",
    },
    /*more_information_required: {
        id: 5,
        name: "More Info Required",
        tag_type: "warning"
    },
    pending_data: {
        id: 6,
        name: "Pending Data",
        tag_type: "warning"
    },*/
};
